import store from '@app/store';

export const isAuthenticated = (): boolean =>
  !!store.getState().users.currentUser;
